
<template>
  <div class="stats-widget-wrapper">
    <el-button 
      @click="showDialog"
    >
      <span>客户端统计</span>
    </el-button>
    
    <el-dialog
      :visible.sync="dialogVisible"
      width="1024px"
      top="6vh"
      custom-class="modern-stats-dialog"
      :close-on-click-modal="false"
      append-to-body
      @opened="initCharts"
    >
      <div class="dialog-header-custom">
        <div class="header-title">
          <i class="iconfont icon-layout"></i>
          <span>客户端统计</span>
        </div>
        <div class="dialog-close-btn" @click="dialogVisible = false">
          <i class="iconfont icon-xianxing"></i>
        </div>
      </div>
      
      <div class="dialog-body-custom">
        <div class="charts-grid">
          <div class="chart-card type-card">
            <div class="card-header">
              <div class="header-decoration"></div>
              <div class="header-main">
                <div class="header-text">
                  <h4>客户端分布</h4>
                </div>
              </div>
            </div>
            <div ref="typeChartRef" class="chart-render-area"></div>
          </div>
          
          <div class="chart-card device-card">
            <div class="card-header">
              <div class="header-decoration"></div>
              <div class="header-main">
                <div class="header-text">
                  <h4>机型占比</h4>
                </div>
              </div>
            </div>
            <div ref="deviceChartRef" class="chart-render-area"></div>
          </div>

          <div class="chart-card version-card">
            <div class="card-header">
              <div class="header-decoration"></div>
              <div class="header-main">
                <div class="header-text">
                  <h4>App版本分布</h4>
                </div>
              </div>
            </div>
            <div ref="versionChartRef" class="chart-render-area"></div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  data() {
    return {
      dialogVisible: false,
      typeChart: null,
      deviceChart: null,
      versionChart: null,
      typeData: [],
      deviceData: [],
      versionData: [],
      typeColorPool: [
        ['#60A5FA', '#3B82F6'],
        ['#4ADE80', '#22C55E'],
        ['#FDBA74', '#FB923C'],
        ['#C4B5FD', '#A855F7'],
        ['#F87171', '#EF4444']
      ],
      deviceColorPool: [
        ['#60A5FA', '#3B82F6'],
        ['#FDBA74', '#FB923C'],
        ['#4ADE80', '#22C55E'],
        ['#C4B5FD', '#A855F7'],
        ['#9CA3AF', '#6B7280'],
        ['#F87171', '#EF4444'],
        ['#A78BFA', '#8B5CF6'],
        ['#34D399', '#10B981']
      ],
      versionColorPool: [
        ['#F472B6', '#EC4899'],
        ['#FB923C', '#F97316'],
        ['#22D3EE', '#06B6D4'],
        ['#9CA3AF', '#6B7280']
      ]
    };
  },
  methods: {
    showDialog() {
      this.fetchData();
      this.dialogVisible = true;
    },
    async fetchData() {
      try {
        //     this.typeData = this.buildPieData([
        //   { Name: 'APP用户', Value: 65 },
        //   { Name: 'Web用户', Value: 35 }
        // ], this.typeColorPool);
        // this.deviceData = this.buildPieData([
        //   { Name: 'iPhone', Value: 40 },
        //   { Name: 'iPad', Value: 15 },
        //   { Name: 'MacOS', Value: 20 },
        //   { Name: 'Android', Value: 20 },
        //   { Name: 'Windows', Value: 5 }
        // ], this.deviceColorPool);
        // this.versionData = this.buildVersionData([
        //   { AppVersion: '1.1.12', VersionCnt: 814 },
        //   { AppVersion: '5.0', VersionCnt: 27 },
        //   { AppVersion: '1.1.20', VersionCnt: 10 },
        //   { AppVersion: '1.1.11', VersionCnt: 7 },
        //   { AppVersion: '16_Flu', VersionCnt: 3 },
        //   { AppVersion: '5_Flut', VersionCnt: 1 }
        // ]);
        const res = await this.$api.StuClientTypeSummary();
        if (res) {
          const data = res.Data || res;
          // 客户端类型分布：APP用户 + Web用户
          const appCnt = Number(data.AppCnt || 0);
          const webCnt = Number(data.TotalCnt || 0) - appCnt;
          this.typeData = this.buildPieData([
            { Name: 'APP用户', Value: appCnt  },
            { Name: 'Web用户', Value: webCnt > 0 ? webCnt : 0 }
          ], this.typeColorPool);
          // 机型分布
          this.deviceData = this.buildPieData([
            { Name: 'iPhone', Value: Number(data.IphoneCnt || 0) },
            { Name: 'iPad', Value: Number(data.IpadCnt || 0) },
            { Name: 'MacOS', Value: Number(data.MacCnt || 0) },
            { Name: 'Android', Value: Number(data.AndroidCnt || 0) },
            { Name: 'Windows', Value: Number(data.WinCnt || 0) }
          ], this.deviceColorPool);
          // App版本分布：前3条单独显示，剩余合并为"其它版本"
          this.versionData = this.buildVersionData(data.AppVersionInfo);
        }
      } catch (err) {
        console.error('获取客户端统计数据失败:', err);
    
      }
      this.updateCharts();
    },
    updateCharts() {
      if (this.typeChart) {
        this.renderTypeChart();
      }
      if (this.deviceChart) {
        this.renderDeviceChart();
      }
      if (this.versionChart) {
        this.renderVersionChart();
      }
    },
    buildPieData(rawList, colorPool) {
      if (!rawList || !Array.isArray(rawList)) return [];
      const result = rawList.map((item, index) => {
        const colors = colorPool[index % colorPool.length];
        const name = item.Name || item.name || item.ClientType || item.DeviceType || item.Type || '未知';
        const value = Number(item.Value || item.Count || item.Cnt || item.value || item.count || 0);
        return {
          name,
          value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: colors[0] },
              { offset: 1, color: colors[1] }
            ])
          }
        };
      });
      // 只有全部数据都为0时才返回空数组（不显示）
      const hasData = result.some(item => item.value > 0);
      return hasData ? result : [];
    },
    buildVersionData(appVersionInfo) {
      if (!appVersionInfo || !Array.isArray(appVersionInfo) || appVersionInfo.length === 0) {
        return [];
      }
      const topN = appVersionInfo.slice(0, 3);
      const rest = appVersionInfo.slice(3);
      const restCount = rest.reduce((sum, item) => sum + Number(item.VersionCnt || 0), 0);

      const rawList = topN.map(item => ({
        Name: item.AppVersion || '未知',
        Value: Number(item.VersionCnt || 0)
      }));
      if (restCount > 0) {
        rawList.push({ Name: '其它版本', Value: restCount });
      }
      return this.buildPieData(rawList, this.versionColorPool);
    },
    initCharts() {
      if (this.typeChart) {
        this.typeChart.dispose();
      }
      if (this.deviceChart) {
        this.deviceChart.dispose();
      }
      if (this.versionChart) {
        this.versionChart.dispose();
      }

      this.typeChart = echarts.init(this.$refs.typeChartRef);
      this.deviceChart = echarts.init(this.$refs.deviceChartRef);
      this.versionChart = echarts.init(this.$refs.versionChartRef);

      this.renderTypeChart();
      this.renderDeviceChart();
      this.renderVersionChart();

      this.$nextTick(() => {
        this.typeChart && this.typeChart.resize();
        this.deviceChart && this.deviceChart.resize();
        this.versionChart && this.versionChart.resize();
      });

      window.addEventListener('resize', this.handleResize);
    },
    renderTypeChart() {
      const data = this.typeData;
      const total = data.reduce((s, d) => s + d.value, 0);
      const option = {
        graphic: [
          {
            type: 'text',
            left: 'center',
            top: '38%',
            style: {
              text: total.toLocaleString(),
              fontSize: 28,
              fontWeight: 700,
              fill: '#1F2937',
              textAlign: 'center'
            }
          },
          {
            type: 'text',
            left: 'center',
            top: '58%',
            style: {
              text: '客户端总数',
              fontSize: 12,
              fontWeight: 500,
              fill: '#9CA3AF',
              textAlign: 'center'
            }
          }
        ],
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255, 255, 255, 0.98)',
          borderColor: '#e5e7eb',
          borderWidth: 1,
          padding: [12, 16],
          textStyle: {
            color: '#374151'
          },
          formatter: '<div style="font-weight:600;margin-bottom:6px;font-size:14px;">{b}</div><div style="font-size:20px;font-weight:bold;color:#3870F6;">{d}%</div>',
          extraCssText: 'border-radius: 12px; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);'
        },
        legend: {
          orient: 'horizontal',
          bottom: '0%',
          itemWidth: 16,
          itemHeight: 16,
          itemGap: 24,
          textStyle: {
            color: '#6b7280',
            fontSize: 13,
            fontWeight: 500
          },
          data: this.typeData.map(d => d.name)
        },
        series: [
          {
            name: '客户端类型',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#ffffff',
              borderWidth: 3
            },
            label: {
              show: true,
              formatter: '{b}: {c}人 · {d}%',
              fontSize: 12,
              color: '#374151',
              fontWeight: 600,
              overflow: 'none',
              width: 0
            },
            labelLine: {
              show: true,
              length: 8,
              length2: 6
            },
            labelLayout: {
              hideOverlap: false
            },
            emphasis: {
              scale: true,
              scaleSize: 12,
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.15)'
              }
            },
            data: data
          },
          {
            name: '装饰环',
            type: 'pie',
            radius: ['38%', '42%'],
            center: ['50%', '50%'],
            itemStyle: {
              color: '#f3f4f6',
              borderWidth: 0
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: [{ value: 100 }]
          }
        ]
      };
      this.typeChart.setOption(option);
    },
    renderDeviceChart() {
      const data = this.deviceData;
      const total = data.reduce((s, d) => s + d.value, 0);
      const option = {
        graphic: [
          {
            type: 'text',
            left: 'center',
            top: '38%',
            style: {
              text: total.toLocaleString(),
              fontSize: 28,
              fontWeight: 700,
              fill: '#1F2937',
              textAlign: 'center'
            }
          },
          {
            type: 'text',
            left: 'center',
            top: '58%',
            style: {
              text: '机型总数',
              fontSize: 12,
              fontWeight: 500,
              fill: '#9CA3AF',
              textAlign: 'center'
            }
          }
        ],
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255, 255, 255, 0.98)',
          borderColor: '#e5e7eb',
          borderWidth: 1,
          padding: [12, 16],
          textStyle: {
            color: '#374151'
          },
          formatter: '<div style="font-weight:600;margin-bottom:6px;font-size:14px;">{b}</div><div style="font-size:20px;font-weight:bold;color:#3870F6;">{d}%</div>',
          extraCssText: 'border-radius: 12px; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);'
        },
        legend: {
          orient: 'horizontal',
          bottom: '0%',
          itemWidth: 16,
          itemHeight: 16,
          itemGap: 16,
          textStyle: {
            color: '#6b7280',
            fontSize: 12,
            fontWeight: 500
          },
          data: this.deviceData.map(d => d.name)
        },
        series: [
          {
            name: 'APP机型',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#ffffff',
              borderWidth: 3
            },
            label: {
              show: true,
              formatter: '{b}: {c}人 · {d}%',
              fontSize: 11,
              color: '#374151',
              fontWeight: 600,
              overflow: 'none',
              width: 0
            },
            labelLine: {
              show: true,
              length: 6,
              length2: 6
            },
            labelLayout: {
              hideOverlap: false
            },
            emphasis: {
              scale: true,
              scaleSize: 12,
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.15)'
              }
            },
            data: data
          },
          {
            name: '装饰环',
            type: 'pie',
            radius: ['38%', '42%'],
            center: ['50%', '50%'],
            itemStyle: {
              color: '#f3f4f6',
              borderWidth: 0
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: [{ value: 100 }]
          }
        ]
      };
      this.deviceChart.setOption(option);
    },
    renderVersionChart() {
      const data = this.versionData;
      if (!data || data.length === 0) {
        this.versionChart.clear();
        return;
      }
      const total = data.reduce((s, d) => s + d.value, 0);
      const option = {
        graphic: [
          {
            type: 'text',
            left: 'center',
            top: '38%',
            style: {
              text: total.toLocaleString(),
              fontSize: 28,
              fontWeight: 700,
              fill: '#1F2937',
              textAlign: 'center'
            }
          },
          {
            type: 'text',
            left: 'center',
            top: '58%',
            style: {
              text: '版本总数',
              fontSize: 12,
              fontWeight: 500,
              fill: '#9CA3AF',
              textAlign: 'center'
            }
          }
        ],
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255, 255, 255, 0.98)',
          borderColor: '#e5e7eb',
          borderWidth: 1,
          padding: [12, 16],
          textStyle: {
            color: '#374151'
          },
          formatter: '<div style="font-weight:600;margin-bottom:6px;font-size:14px;">{b}</div><div style="font-size:20px;font-weight:bold;color:#EC4899;">{d}%</div>',
          extraCssText: 'border-radius: 12px; box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);'
        },
        legend: {
          orient: 'horizontal',
          bottom: '0%',
          itemWidth: 16,
          itemHeight: 16,
          itemGap: 16,
          textStyle: {
            color: '#6b7280',
            fontSize: 12,
            fontWeight: 500
          },
          data: data.map(d => d.name)
        },
        series: [
          {
            name: 'App版本',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#ffffff',
              borderWidth: 3
            },
            label: {
              show: true,
              formatter: '{b}: {c}人 · {d}%',
              fontSize: 11,
              color: '#374151',
              fontWeight: 600,
              overflow: 'none',
              width: 0
            },
            labelLine: {
              show: true,
              length: 6,
              length2: 6
            },
            labelLayout: {
              hideOverlap: false
            },
            emphasis: {
              scale: true,
              scaleSize: 12,
              itemStyle: {
                shadowBlur: 20,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.15)'
              }
            },
            data: data
          },
          {
            name: '装饰环',
            type: 'pie',
            radius: ['33%', '37%'],
            center: ['50%', '50%'],
            itemStyle: {
              color: '#f3f4f6',
              borderWidth: 0
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: [{ value: 100 }]
          }
        ]
      };
      this.versionChart.setOption(option);
    },
    handleResize() {
      this.typeChart && this.typeChart.resize();
      this.deviceChart && this.deviceChart.resize();
      this.versionChart && this.versionChart.resize();
    },
    closeDialog() {
      this.dialogVisible = false;
      window.removeEventListener('resize', this.handleResize);
      if (this.typeChart) {
        this.typeChart.dispose();
        this.typeChart = null;
      }
      if (this.deviceChart) {
        this.deviceChart.dispose();
        this.deviceChart = null;
      }
      if (this.versionChart) {
        this.versionChart.dispose();
        this.versionChart = null;
      }
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (!newVal) {
        this.closeDialog();
      }
    }
  },
  beforeDestroy() {
    this.closeDialog();
  }
};
</script>

<style lang="less" scoped>
.stats-widget-wrapper {
  display: inline-block;
  margin-left: 16px;
}

// 触发按钮：精致渐变与微交互
.stats-trigger-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.25);
  letter-spacing: 0.5px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(124, 58, 237, 0.35);
    background: linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(124, 58, 237, 0.2);
  }
  
  .iconfont {
    font-size: 16px;
  }
}

// 对话框自定义头部
.dialog-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 28px;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  
  .header-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    
    i {
      color: #7C3AED;
      font-size: 20px;
    }
  }
}

.dialog-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #9CA3AF;
  transition: all 0.2s ease;
  
  &:hover {
    background: #F3F4F6;
    color: #4B5563;
    transform: rotate(90deg);
  }
  
  .iconfont {
    font-size: 16px;
  }
}

.dialog-body-custom {
  padding:16px;
   padding-bottom: 28px;
  background: #FAFAFA;
}

// 图表网格布局
.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

// 卡片通用样式
.chart-card {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  padding-top: 0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  border: 1px solid #F3F4F6;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  
  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
    transform: translateY(-2px);
    
    .header-icon {
      transform: scale(1.05);
      
      &::before {
        opacity: 1;
      }
    }
  }
  
  .card-header {
    display: flex;
    align-items: center;
    position: relative;
    
    .header-decoration {
      width: 4px;
      height: 48px;
      border-radius: 2px;
      flex-shrink: 0;
      margin-right: 16px;
    }
    
    .header-main {
      display: flex;
      align-items: center;
      gap: 14px;
      flex: 1;
    }
    
    .header-icon {
      width: 48px;
      height: 48px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      color: #fff;
      flex-shrink: 0;
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        inset: -2px;
        border-radius: 16px;
        opacity: 0;
        transition: opacity 0.3s ease;
      }
    }
    
    .header-text {
      display: flex;
      flex-direction: column;
      gap: 4px;
      
      h4 {
        margin: 0;
        font-size: 17px;
        font-weight: 700;
        color: #111827;
        line-height: 1.3;
        letter-spacing: -0.3px;
      }
      
      .subtitle {
        font-size: 12px;
        color: #9CA3AF;
        font-weight: 500;
        letter-spacing: 0.5px;
        text-transform: uppercase;
      }
    }
    
    .header-meta {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 2px;
      padding: 8px 16px;
      background: linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.4) 100%);
      border-radius: 12px;
      border: 1px solid rgba(0,0,0,0.04);
      
      .meta-value {
        font-size: 18px;
        font-weight: 700;
        color: #1F2937;
        line-height: 1;
      }
      
      .meta-label {
        font-size: 11px;
        color: #9CA3AF;
        font-weight: 500;
        letter-spacing: 0.3px;
      }
    }
  }
  
  .chart-render-area {
    width: 100%;
    min-height: 300px;
    flex: 1;
  }
}

.type-card {
  
  .header-icon {
    background: linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%);
    box-shadow: 0 6px 16px rgba(59, 130, 246, 0.35);
    
    &::before {
      background: linear-gradient(135deg, rgba(59,130,246,0.3) 0%, rgba(37,99,235,0.1) 100%);
    }
  }
  
  .header-meta {
    background: linear-gradient(135deg, rgba(59,130,246,0.08) 0%, rgba(37,99,235,0.04) 100%);
    border-color: rgba(59,130,246,0.15);
    
    .meta-value {
      color: #3B82F6;
    }
  }
}

.device-card {
  
  .header-icon {
    background: linear-gradient(135deg, #A78BFA 0%, #8B5CF6 100%);
    box-shadow: 0 6px 16px rgba(139, 92, 246, 0.35);
    
    &::before {
      background: linear-gradient(135deg, rgba(139,92,246,0.3) 0%, rgba(124,58,237,0.1) 100%);
    }
  }
  
  .header-meta {
    background: linear-gradient(135deg, rgba(139,92,246,0.08) 0%, rgba(124,58,237,0.04) 100%);
    border-color: rgba(139,92,246,0.15);
    
    .meta-value {
      color: #8B5CF6;
    }
  }
}

.version-card {
  
  .header-icon {
    background: linear-gradient(135deg, #F472B6 0%, #EC4899 100%);
    box-shadow: 0 6px 16px rgba(236, 72, 153, 0.35);
    
    &::before {
      background: linear-gradient(135deg, rgba(236,72,153,0.3) 0%, rgba(219,39,119,0.1) 100%);
    }
  }
  
  .header-meta {
    background: linear-gradient(135deg, rgba(236,72,153,0.08) 0%, rgba(219,39,119,0.04) 100%);
    border-color: rgba(236,72,153,0.15);
    
    .meta-value {
      color: #EC4899;
    }
  }
}

@media (max-width: 768px) {
  .charts-grid {
    grid-template-columns: 1fr;
  }
  
  .card-header {
    flex-wrap: wrap;
    gap: 12px;
    
    .header-decoration {
      height: 36px;
    }
    
    .header-icon {
      width: 40px;
      height: 40px;
      font-size: 18px;
    }
    
    .header-meta {
      margin-left: auto;
      padding: 0px 12px;
      
      .meta-value {
        font-size: 16px;
      }
    }
  }
}
</style>

<style lang="less">
.modern-stats-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
    margin-top: 6vh !important;
  }
  
  .el-dialog__header {
    padding: 0;
    margin: 0;
  }
  
  .el-dialog__body {
    padding: 0;
    background: #FAFAFA;
  }
  
  .el-dialog__footer {
    display: none;
  }
  
  .el-dialog__close {
    display: none;
  }
}
</style>